

import React, { useState, useEffect } from "react";
import axios from "axios";
import apiUrl from "../../environment/Api";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

function JobDetails() {
  const [JobDetails, setJobDetails] = useState([]);
  const [responseData, setResponseData] = useState([]);

  const { id } = useParams();
  console.log("this is params", id)


  useEffect(() => {
    fetchDatas();
    fetchData();
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchDatas = async () => {
    try {
      const responseStaff = await axios.get(apiUrl + `/jobportalinfo/${id}`);
      setJobDetails(responseStaff.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };



  const fetchData = async () => {
    try {
      const response = await axios.get(apiUrl + `/jobapplication/${id}`);
      console.log("Response from server:", response.data);
      setResponseData(response.data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const [deleteShowModals, setDeleteShowModals] = useState(false);

  // Open modal to delete
  const handleOpenModal = (_id, student_name) => {
    setdeleteid(_id); // Set the ID of the job application to delete
    setdeletename(student_name); // Set the name of the student
    setDeleteShowModals(true); // Open the modal
  };

  // Perform the delete operation
  const handleDelete = async () => {
    try {
      // Send delete request using the ID
      const response = await axios.delete(apiUrl + `/jobapplication/${getdeleteid}`);
      console.log("Delete response:", response);
      toast.success("Delete successfully!");
      setDeleteShowModals(false);
      fetchData(); // Refresh the job applications
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete.");
    }
  };

  // Close the delete modal
  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const navigate = useNavigate();

  const handleInfo = (id) => {
    navigate(`/jobMemberDetail/${id}`)
  }

  return (
    <>
      <div className="" style={{ marginTop: "-80px" }}>
        <div className="row mb-3">
          <div className="col-lg-11">
            <Link to="/dashboard" className="text-secondary dashBoard_text">
              <b>Dashboard / </b>
            </Link>
            <Link to="/jobportal" className="text-secondary dashBoard_text">
              <b>JobPortal / </b>
            </Link>
            <Link to="" className="text-danger dashBoard_text">
              <b>JobDetails</b>
            </Link>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-lg-12">
          <h4>
            <b>Job Details</b>
          </h4>
          <div className="card">
            <div className="row mt-1">
              <div className="col-lg-6">
                <div className="row p-1">
                  <div className="col-lg-5">
                    <strong>Title :</strong>
                  </div>
                  <div className="col-lg-6 text-secondary">
                    {JobDetails.designation || ""}
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-lg-5">
                    <strong>Post Date :</strong>
                  </div>
                  <div className="col-lg-6 text-secondary">
                    {JobDetails.start_date
                      ? new Date(JobDetails.start_date).toLocaleDateString("en-CA")
                      : ""}
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-lg-5">
                    <strong>DeadLine :</strong>
                  </div>
                  <div className="col-lg-6 text-secondary">
                    {JobDetails.deadline
                      ? new Date(JobDetails.deadline).toLocaleDateString("en-CA")
                      : ""}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="row p-1">
                  <div className="col-lg-5">
                    <strong>Vacancies :</strong>
                  </div>
                  <div className="col-lg-6 text-secondary">
                    {JobDetails.no_of_vacancies || ""}
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-lg-5">
                    <strong>Location :</strong>
                  </div>
                  <div className="col-lg-6 text-secondary">
                    {JobDetails.location || ""}
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-lg-5">
                    <strong>Applied :</strong>
                  </div>
                  <div className="col-lg-6 text-secondary">
                    {responseData.length || ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <h4>
          <b>Job Application</b>
        </h4>
        <div className="card mt-1">
          <div className="mt-1">
            <table className="table table-striped ">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile No </th>
                  <th>Exp</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {responseData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{new Date(item.dateofbirth).toLocaleDateString()}</td>
                    <td>{item.name}</td>
                    <td>{item.email_address}</td>
                    <td>{item.contact_number}</td>
                    <td>{item.experience}</td>

                    <td className="text-center">
                      <button
                        className="btn delete mx-1"
                        onClick={() => handleOpenModal(item._id, item.name)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                      <button className="btn"
                        onClick={() => handleInfo(item._id)}
                      >
                        <i className="fa-solid fa-circle-info"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* modal */}
      <Modal className="modal" show={deleteShowModals} onHide={handleCloseModal}>
        <Modal.Header>
          <p>Are you sure you want to Delete?</p>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label d-flex">
            <h5 className="mx-1">Student:</h5>
            <h5>{getdeletename}</h5>
          </label>
        </Modal.Body>
        <Modal.Footer>
          <Button className="cancelbut" variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button className="submitbut" variant="primary" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default JobDetails;
